<template>
  <div :class="['title-container', space?'space':'nospace'] ">
    <div v-if="space" class="line" :style="{ background: lineColor }" />
    <span class="title" :style="{ color: color }"> <span>{{ title }}</span> </span>
  </div>
</template>
<script>
export default {
  name: 'Title',
  props: {
    color: {
      type: String,
      default: '#3370FF'
    },
    lineColor: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '66'
    },
    space: {
      // 标题修饰符是否占用空间,默认占用
      type: Boolean,
      default: true
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
.title-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .line {
    width: 4px;
    height: 16px;
    background: #3370FF;
  }
  .title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    position: relative;
    >span {
      color: #1F2329;
    }
  }
  &.space {
    .title {
      margin-left: 12px;
    }
  }
  &.nospace {
    .title::before {
      content: '';
      width: 4px;
      height: 16px;
      background: currentColor;
      position: absolute;
      left: -16px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
